import '../views/footer.css'
import '../style.css'
import { getOpeningStatus } from '../utils/openingHours'
import HoursBadge from './HoursBadge'
import { useAnnouncement } from '../context/AnnouncementContext'

const Footer = ({ menu }) => {

  const openingHours = menu?.openingHours ?? {}
  const onlineOrderHours = menu?.onlineOrderHours ?? {}

  const {
    openDays,
    onlineOrderDays,
    announcementActive
  } = useAnnouncement()

  const {
    isOpen,
    isOnlineOrderOpen
  } = getOpeningStatus(new Date(), {
    openDays,
    onlineOrderDays,
    openingHours,
    onlineOrderHours
  })

  const status =
    announcementActive
      ? 'closed-temp'
      : isOpen && isOnlineOrderOpen
        ? 'open-full'
        : isOpen
          ? 'open-physical-only'
          : 'closed'

  const dotOpen =
    status !== 'closed' && status !== 'closed-temp'

  const effectiveLabel =
    status === 'closed-temp'
      ? 'Fermée temporairement'
      : status === 'open-full'
        ? 'Ouvert • commande en ligne'
        : status === 'open-physical-only'
          ? 'Ouvert (sur place uniquement)'
          : 'Fermé'

  return (
    <footer className="footer-root">
      <div className="footer-inner">

        {/* Brand */}
        <div className="footer-column footer-brand">
          <h3 className="footer-brand-title">
            La friterie de Lalaing
          </h3>

          <p className="footer-brand-tagline">
            Frites croustillantes et spécialités belges au cœur d&apos;Écaussinnes-Lalaing.
          </p>

          {/* 🔥 VERSION SIMPLE (comme navbar mais sans interaction) */}
          <HoursBadge
            dotOpen={dotOpen}
            effectiveLabel={effectiveLabel}
          />
        </div>

        {/* Contact */}
        <div className="footer-column footer-contact">
          <h4 className="footer-column-title">Informations</h4>

          <ul className="footer-list">
            <li className="footer-list-item">
              <a href="tel:067 33 99 39">067 33 99 39</a>
            </li>

            <li className="footer-list-item">
              <a
                href="https://www.google.com/maps/place/Friterie+de+Lalaing/"
                target="_blank"
                rel="noreferrer"
              >
                Rue de la Grande Ronce 7<br />
                7190 Écaussinnes-Lalaing
              </a>
            </li>
          </ul>
        </div>

        {/* Horaires fixes */}
        <div className="footer-column footer-hours">
          <h4 className="footer-column-title">Horaires</h4>

          <ul className="footer-list">
            <li>Mercredi – Dimanche : 17h30 – 21h00</li>
            <li>Lundi - Mardi: fermé</li>
            <li>Commandes en ligne : mer., jeu. et sam. jusqu&apos;à 20h20</li>
            <li>Sauf contre indication</li>
          </ul>
        </div>

        {/* Links */}
        <div className="footer-column footer-links">
          <h4 className="footer-column-title">Liens utiles</h4>

          <ul className="footer-list">
            <li><a href="/menu">Voir le menu</a></li>
            <li><a href="/patrimoine">Patrimoine</a></li>
            <li>
              <a
                href="https://www.google.com/maps/place/Friterie+de+Lalaing/"
                target="_blank"
                rel="noreferrer"
              >
                Avis Google
              </a>
            </li>
          </ul>
        </div>

      </div>

      {/* Bottom */}
      <div className="footer-bottom">
        <span>© 2026 Friterie de Lalaing</span>
        <span>
          Site réalisé par{' '}
          <a href="https://gaetancrabeels.com/" target="_blank" rel="noreferrer">
            Gaëtan Crabeels
          </a>
        </span>
        <span>Frites & amour 🇧🇪</span>
      </div>
    </footer>
  )
}

export default Footer